// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Thymosin beta 4 09.17.26" (1d2f1089-9308-4c9b-bccb-dee69a0e8006). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiThymosinBeta4Questions = [
  {
    field: 'mdiThymosinBeta4_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiThymosinBeta4_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiThymosinBeta4_wereSorryBasedPreviousAnswer',
    label:
      "We're sorry, based on a previous answer, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '20a2702f-ffc7-4255-84fb-db568f25b130',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiThymosinBeta4_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1TnvLKsLLJdUe6poFand0F_-VBvHg3muz/view)',
    answer: {
      type: 'text',
      name: 'mdiThymosinBeta4_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: 'f8a8568d-71e5-45d1-865b-c4406c457f82' }
  },
  {
    field: 'mdiThymosinBeta4_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'accelerated_wound_healing_and_tissue_rep',
          value: 'Accelerated wound healing and tissue repair'
        },
        {
          key: 'enhanced_recovery_from_muscle_tendon_and',
          value: 'Enhanced recovery from muscle, tendon, and ligament injuries'
        },
        {
          key: 'reduced_inflammation_in_acute_and_chroni',
          value: 'Reduced inflammation in acute and chronic conditions'
        },
        {
          key: 'decreased_scar_formation_and_improved_co',
          value: 'Decreased scar formation and improved cosmetic outcomes'
        },
        {
          key: 'cardiac_tissue_protection_and_repair_fol',
          value:
            'Cardiac tissue protection and repair following heart attack (myocardial infarction)'
        },
        {
          key: 'improved_outcomes_in_congenital_heart_su',
          value: 'Improved outcomes in congenital heart surgery'
        },
        {
          key: 'support_for_spinal_cord_injuries_and_tra',
          value:
            'Support for spinal cord injuries and traumatic brain injury recovery'
        },
        { key: 'eye_health_benefits', value: 'Eye health benefits' },
        {
          key: 'enhanced_recovery_from_surgical_procedur',
          value: 'Enhanced recovery from surgical procedures'
        },
        {
          key: 'nerve_tissue_regeneration_and_neuroprote',
          value: 'Nerve tissue regeneration and neuroprotection'
        },
        {
          key: 'improved_flexibility_and_range_of_motion',
          value: 'Improved flexibility and range of motion'
        },
        {
          key: 'support_for_autoimmune_and_inflammatory',
          value:
            'Support for autoimmune and inflammatory conditions (under investigation)'
        }
      ]
    },
    extras: { mdiQuestionId: 'a442ee21-7605-40bd-8e44-0ec79db78d38' }
  },
  {
    field: 'mdiThymosinBeta4_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '47a4ce47-6a5b-4c11-a72d-c617b88685f7' }
  },
  {
    field: 'mdiThymosinBeta4_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiThymosinBeta4_peptidesUsedPreviously',
      rows: 4
    },
    extras: { mdiQuestionId: '96c04062-2290-4a54-a333-e4023f1b1885' }
  },
  {
    field: 'mdiThymosinBeta4_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '26fbedc9-5b56-467b-b589-e55a1149e36f' }
  },
  {
    field: 'mdiThymosinBeta4_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiThymosinBeta4_reactionSideEffect',
      rows: 4
    },
    extras: { mdiQuestionId: '9463ad23-c4df-4084-b9fe-a3d028a8ebb0' }
  },
  {
    field: 'mdiThymosinBeta4_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        {
          key: 'any_condition_that_causes_advanced_fibro',
          value: 'Any condition that causes advanced fibrosis'
        },
        { key: 'psychiatric_disorder', value: 'Psychiatric disorder' },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'other_please_specify', value: 'Other (please specify)' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '71aa127b-6425-478e-aad8-bd689db475d3' }
  },
  {
    field: 'mdiThymosinBeta4_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: 'da906f27-893c-4deb-b438-d53dd04abae9' }
  },
  {
    field: 'mdiThymosinBeta4_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'chemotherapy_or_cancer_related_treatment',
          value: 'Chemotherapy or cancer-related treatment'
        },
        { key: 'immunosuppressants', value: 'Immunosuppressants' },
        {
          key: 'corticosteroids_like_prednisone_dexameth',
          value: 'Corticosteroids (like prednisone, dexamethasone, etc)'
        },
        { key: 'tnf_inhibitors', value: 'TNF inhibitors' },
        { key: 'calcineurin_inhibitors', value: 'Calcineurin inhibitors' },
        { key: 'alcohol_use', value: 'Alcohol use' },
        { key: 'warfarin', value: 'Warfarin' },
        {
          key: 'blood_thinners_like_eliquis_xarelto_etc',
          value: 'Blood thinners (like eliquis, xarelto, etc)'
        },
        {
          key: 'aspirin_clopidogrel_or_other_antiplatele',
          value: 'Aspirin, clopidogrel or other antiplatelet medication'
        },
        { key: 'growth_factor_peptides', value: 'Growth factor peptides' },
        { key: 'nsaids', value: 'NSAIDs' },
        { key: 'methotrexate', value: 'Methotrexate' },
        { key: 'antiviral_medication', value: 'Antiviral medication' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'e91f1015-f405-4593-8e0a-4bf4875b331a' }
  },
  {
    field: 'mdiThymosinBeta4_manyAlcoholicDrinksConsumePer',
    label: 'How many alcoholic drinks do you consume per week?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'o_1_3_drinks', value: '1-3 drinks' },
        { key: 'o_3_6_drinks', value: '3-6 drinks' },
        { key: 'o_6_9_drinks', value: '6-9 drinks' },
        { key: 'o_10_or_more_drinks', value: '10 or more drinks' }
      ]
    },
    extras: { mdiQuestionId: '755ee64d-bfee-499d-9858-d9678a0f28c6' }
  },
  {
    field: 'mdiThymosinBeta4_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'ef04347f-4e1f-4db2-a313-9b06ad357e35' }
  },
  {
    field: 'mdiThymosinBeta4_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '8c802bb3-772c-478e-8e07-0e61223ad718' }
  },
  {
    field: 'mdiThymosinBeta4_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiThymosinBeta4_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: 'c410ec72-cf3f-458d-a55f-be02309192c9' }
  },
  {
    field: 'mdiThymosinBeta4_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiThymosinBeta4_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: 'b6d5805d-98f5-467e-8395-87525ae362aa' }
  },
  {
    field: 'mdiThymosinBeta4_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiThymosinBeta4AnswerField = Partial<
  QuestionAnswerMap<typeof mdiThymosinBeta4Questions>
>;

export default mdiThymosinBeta4Questions;
